// @flow
import { AUDIO_QUALITY_PREVIEW } from '../constants';
import AudioTagPlayer from '../lib/players/Player';
import HlsPlayer from '../lib/players/HlsPlayer';
import AdsPlayer from '../lib/players/AdsPlayer';
import {
  selectClientSupportsMP3,
  selectClientSupportsNativeAAC,
  selectClientSupportsPolyfilledAAC,
  selectClientSupportsPlayback,
} from './playbackSupport';

type StateResolver = (trackId: string, quality: number) => any;

export function selectPlayerClass(state: Object) {
  if (selectClientSupportsMP3(state)) {
    return AudioTagPlayer;
  }

  if (selectClientSupportsNativeAAC()) {
    return AudioTagPlayer;
  }

  if (selectClientSupportsPolyfilledAAC()) {
    return HlsPlayer;
  }

  return null;
}

function createWindowAudioDevice() {
  return new window.Audio();
}

function createDocumentVideoDevice() {
  return document.createElement('video');
}

function selectDeviceClass(PlayerClass) {
  if (PlayerClass === AudioTagPlayer) {
    return createWindowAudioDevice;
  }

  if (PlayerClass === HlsPlayer) {
    return createDocumentVideoDevice;
  }

  return null;
}

export function selectPlayerInstance(state: Object, stateResolver: StateResolver) {
  if (!selectClientSupportsPlayback(state)) {
    throw new Error('Client does not support playback!');
  }

  const PlayerClass = selectPlayerClass(state);
  const deviceConstructor = selectDeviceClass(PlayerClass);
  if (PlayerClass) {
    return new PlayerClass(stateResolver, AUDIO_QUALITY_PREVIEW, deviceConstructor);
  }

  return null;
}

export function selectAdsPlayerInstance(urlResolver: Function) {
  return new AdsPlayer(urlResolver, createWindowAudioDevice);
}
